import React from 'react';
import { ArrowForward as ArrowIcon } from '@mui/icons-material';
import { Lnk, BottomCta, usePageMeta } from './shared';
import { SOLUTIONS } from './solutionsData';

const Solutions: React.FC = () => {
  usePageMeta('Solutions');
  return (
    <>
      <section className="page-head">
        <div className="container">
          <h1>Solutions for every kind of organization.</h1>
          <p>One app, shaped to how your community works, whether you’re a single chapter or a national organization.</p>
        </div>
      </section>

      <section className="page-body">
        <div className="container">
          <div className="grid-4">
            {SOLUTIONS.map((s) => (
              <Lnk key={s.slug} to={`/solutions/${s.slug}`} className="solution-card">
                <h3>{s.name}</h3>
                <p>{s.tagline}</p>
                <span className="more">Explore {s.name.toLowerCase()}<ArrowIcon style={{ fontSize: 16 }} aria-hidden="true" /></span>
              </Lnk>
            ))}
          </div>
        </div>
      </section>

      <BottomCta />
    </>
  );
};

export default Solutions;
